import { useParams, useNavigate } from "react-router-dom";
import { api } from "../../utils/apiClient";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import ContentLoader from "../../utils/ContentLoader";
import PrayerRequestForm from "../../components/forms/PrayerRequestForm";

export default function JebaVenduthalgalFormPage() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [initialData, setInitialData] = useState({});
    const [prayerRequestTypeOptions, setprayerRequestTypeOptions] = useState([]);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id) {
            fetchPrayerRequest();
        }
    }, [id]);

    const fetchPrayerRequest = async () => {
        try {
            setLoading(true);
            const res = await api.get(`/prayer-request/${id}`);
            if (!res.data.status) {
                toast.error(res?.data?.message || "Failed to fetch prayer request");
                return;
            }
            setInitialData(res.data.data);
        } catch (err) {
            toast.error(err?.response?.data?.message || "Something went wrong");
            navigate("/prayer-request");
        } finally {
            setLoading(false);
        }
    };

    // =========================
    // FETCH PRAYER REQUEST TYPES
    // =========================
    useEffect(() => {
        fetchPrayerRequestTypes();
    }, []);

    const fetchPrayerRequestTypes = async () => {
        try {
            const res = await api.get("/prayer-request-types");

            const options = res.data.data.map((item) => ({
                value: item.id,
                label: item.name
                    .split("_")
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" "),
            }));

            setprayerRequestTypeOptions(options);
        } catch (err) {
            console.error("Failed to fetch Prayer Request types", err);
        }
    };

    const handleSubmit = async (formData) => {
        try {
            setLoading(true);

            if (id) {
                await api.post(
                    `/prayer-request/${id}`,
                    formData
                );
                toast.success("Prayer request updated successfully");
            } else {
                await api.post(
                    "/prayer-request",
                    formData
                );
                toast.success("Prayer request created successfully");
            }

            navigate("/prayer-request");
        } catch (err) {
            const errorMessage =
                Object.values(
                    err?.response?.data?.errors || {}
                )?.[0]?.[0] ||
                err?.response?.data?.message ||
                "Something went wrong";

            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <ContentLoader />;

    return (
        <PrayerRequestForm
            onSubmit={handleSubmit}
            onCancel={() => navigate("/prayer-request")}
            initialData={initialData}
            prayerRequestTypeOptions={prayerRequestTypeOptions}
        />
    );
}